var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoConstruct(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 30,
    viewBox: "0 0 34 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2129_5577)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.2898 18.1152H17.2898C16.3067 18.1152 15.5098 18.9122 15.5098 19.8952V20.7752C15.5098 21.7583 16.3067 22.5552 17.2898 22.5552H25.2898C26.2728 22.5552 27.0698 21.7583 27.0698 20.7752V19.8952C27.0698 18.9122 26.2728 18.1152 25.2898 18.1152Z",
    stroke: "#767676",
    strokeWidth: 1.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1798 18.1151H16.5298C15.4998 18.1151 14.6798 17.2351 14.7598 16.2151L15.3898 9.10508C15.4598 8.17508 16.2298 7.45508 17.1598 7.45508H19.9498C20.9298 7.45508 21.7298 8.25508 21.7298 9.23508V13.2351H26.1698C26.6598 13.2351 27.0598 13.6351 27.0598 14.1251V17.2351C27.0598 17.7251 26.6598 18.1251 26.1698 18.1251L26.1798 18.1151Z",
    stroke: "#767676",
    strokeWidth: 1.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6199 15.0054H14.8599L15.3099 9.98535H18.6199C19.1099 9.98535 19.5099 10.3854 19.5099 10.8754V14.1154C19.5099 14.6054 19.1099 15.0054 18.6199 15.0054Z",
    stroke: "#767676",
    strokeWidth: 1.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8496 20.335H21.7396",
    stroke: "#767676",
    strokeWidth: 1.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.96 20.335H24.85",
    stroke: "#767676",
    strokeWidth: 1.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7397 20.335H18.6197",
    stroke: "#767676",
    strokeWidth: 1.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.02 8.18457L15.18 11.5646",
    stroke: "#767676",
    strokeWidth: 1.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8698 14.7448L11.0898 11.6748",
    stroke: "#767676",
    strokeWidth: 1.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4698 9.4753C11.6098 8.7553 11.1398 8.0553 10.4198 7.9153C9.69982 7.7753 8.99982 8.2453 8.85982 8.9653L7.06982 18.1153H9.73982L11.4798 9.4753H11.4698Z",
    stroke: "#767676",
    strokeWidth: 1.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.73982 18.1152H7.06982V22.5552H12.3998L9.73982 18.1152Z",
    stroke: "#767676",
    strokeWidth: 1.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2129_5577"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.44,
    height: 16.41,
    fill: "white",
    transform: "translate(6.27979 6.79492)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoConstruct);
export default __webpack_public_path__ + "static/media/ico-construct.4b2edc56bc4312c6c6eaddbe9040eb8a.svg";
export { ForwardRef as ReactComponent };